import _keyBy from "lodash/keyBy";
import _flatMap from "lodash/flatMap";
import _flow from "lodash/flow";
import _map from "lodash/map";
import _filter from "lodash/filter";
import _groupBy from "lodash/groupBy";
import _sortBy from "lodash/sortBy";
import _orderBy from "lodash/orderBy";
import Skill from "models/Skill";
import { IGetFacetsResponse } from "shared-services";

// I don't see another option how to use more properly; each facet has own id, so we can't use it as a key, the solution can
// be introduced her enum on BE lever for levels
const highlightedSkillLeveIds = ["Highly skilled", "Native"];

export function mapFacetsToSkills(
  facetListData: IGetFacetsResponse,
  skillList: Skill[]
) {
  const categoryLookup = _keyBy(facetListData, "id");
  const flatMapFacets = _flatMap(facetListData, (cat) =>
    _flatMap(cat.facetGroups, "facets")
  );
  const facetLookup = _keyBy(flatMapFacets, "id");

  const allLevels = _flatMap(facetListData, "facetLevels");
  const levelLookup = _keyBy(allLevels, "id");

  const transformPipeline = _flow([
    (list) =>
      _map(list, (skill) => {
        const levelName = levelLookup[skill.levelId]?.name;

        return {
          categoryName: categoryLookup[skill.facetCategoryId]?.name,
          facetName: facetLookup[skill.facetId]?.name,
          isHighlighted: highlightedSkillLeveIds.includes(levelName),
          levelName,
        };
      }),
    (list) => _filter(list, (item) => !!item.categoryName && !!item.facetName),
    (list) => _groupBy(list, "categoryName"),
    (grouped) =>
      _map(grouped, (items, categoryName) => [
        categoryName,
        _map(
          _orderBy(
            items,
            [(item) => item.isHighlighted, (item) => item.facetName],
            ["desc", "asc"]
          ),
          (item) => [item.facetName, item.isHighlighted, item.levelName]
        ),
      ]),
    (finalList) => _sortBy(finalList, (pair) => pair[0]),
  ]);

  return transformPipeline(skillList);
}
